var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            display: "flex",
            alignItems: "center",
            "& > :not(:first-child)": {
                marginLeft: spacing(2),
            },
        },
        alignEnd: {
            justifyContent: "flex-end",
        },
        margin: {
            marginBottom: spacing(4),
        },
    });
}, { name: "EuiTableToolbar" });
/**
 * @deprecated since version 2.5.0. Use TableToolbar from epic-ui/table package.
 */
export var TableToolbar = React.forwardRef(function TableToolbar(_a, ref) {
    var _b;
    var className = _a.className, alignEnd = _a.alignEnd, disableMargin = _a.disableMargin, _c = _a.role, role = _c === void 0 ? "toolbar" : _c, props = __rest(_a, ["className", "alignEnd", "disableMargin", "role"]);
    var classes = useStyles();
    return (React.createElement("div", __assign({ role: role, className: clsx(classes.root, className, (_b = {},
            _b[classes.alignEnd] = alignEnd,
            _b[classes.margin] = !disableMargin,
            _b)) }, props, { ref: ref })));
});
//# sourceMappingURL=TableToolbar.js.map